import AdministrativeRepresentativeScreen from './AdministrativeRepresentativeScreen.js';

export default AdministrativeRepresentativeScreen;
